import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailPopinType } from '@app/shared/utils';
import { translateKey } from '@app/shared/utils/static-helpers/translate';
import { RcDialogWrapperComponent } from '../rc-dialog-wrapper/rc-dialog-wrapper.component';
import { TitleCasePipe } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-email-response-poppin',
  templateUrl: './email-response-popin.component.html',
  styleUrls: ['./email-response-popin.component.scss'],
  imports: [RcDialogWrapperComponent, TitleCasePipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailResponsePopinComponent {
  isCollaboratorsEmail: boolean;
  isSuccessPopinType: boolean;
  isRetryAllowed = false;
  error: string;
  mailto = {
    recipient: 'vetservices@royalcanin.zendesk.com',
    subject: $localize`:@@email_subject_issue:`,
    body: $localize`:@@email_body_issue:`,
  };

  /**
   * Initializer
   */
  constructor(
    private _dialogRef: MatDialogRef<EmailResponsePopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.isRetryAllowed = this.data.isRetryAllowed;
      this.mailto.body = $localize`:@@email_body_issue:` + ' : ' + this.data.emailPopintype + ' ' + this.data.error;
      this.isSuccessPopinType = this.data.isSuccessPopinType;
      this.isCollaboratorsEmail = (data.emailPopintype || '') === EmailPopinType.Collaborators;
    }
  }

  close(): void {
    this._dialogRef.close();
  }

  getPoppinTypeDescription(): string {
    if (this.data.emailPopinType === EmailPopinType.Recommendation) return translateKey('email-success_text');
    else if (this.data.emailPopinType === EmailPopinType.Collaborators) return translateKey('invitation-success_text');
    else return translateKey('registration-contact-ok-title');
  }

  retry(): void {
    this.data.retryCallback();
    this.close();
  }
}
